module.exports = __webpack_public_path__ + "static/img/model.4701481.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/model.png
// module id = w87U
// module chunks = 0